import { render } from "./Test.vue?vue&type=template&id=5fbcaa32&scoped=true&ts=true"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"

import "./Test.vue?vue&type=style&index=0&id=5fbcaa32&lang=stylus"
import "./Test.vue?vue&type=style&index=1&id=5fbcaa32&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbcaa32"]])

export default __exports__